import React from 'react';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { useRouter } from '@cp/shared/router';
import { useIsLoggedIn } from '@cp/entities/currentUser';

export const withAuthenticationGuard = <CP extends object>(component: React.FC<CP>) => {
  const FinalComponent: React.FC<CP> = (props) => {
    const router = useRouter();
    const loggedIn = useIsLoggedIn();
    const resolver = useClientWebResolver();

    React.useEffect(() => {
      if (!loggedIn) {
        router.navigate(resolver.resolve({ page: ClientWebPage.Home }), { method: 'replace' });
      }
    }, [loggedIn, resolver, router]);

    const WrappedComponent = component;

    return loggedIn ? <WrappedComponent {...props} /> : null;
  };

  FinalComponent.displayName = `WithAuthenticationGuard(${component.displayName || component.name || 'Component'})`;

  return FinalComponent;
};
